import { formatToSpanishTimeZone } from "../utils/formatDate";
import { GetNotificationsResponsible } from "./ApiCalls/notifications/getNotificationsResponsible";
import { PatchNotificationView } from "./ApiCalls/notifications/patchNotificationView";
import { PatchNotificationViewFeedback } from "./ApiCalls/notifications/patchNotificationViewFeedback";


const authInfoString = localStorage.getItem("authInfo");
const authInfo = authInfoString ? JSON.parse(authInfoString) : {};
const responsible = authInfo.idUser;


export async function GetNotificationsService(t) {

  try {

    const data = await GetNotificationsResponsible(responsible);

    const sortedData = data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    const notifications = sortedData.map(notification => ({
      incident: notification.incident,
      feedback: notification.feedback,
      notification: notification.notification1,
      view: !notification.view ? t("notificationsTable.stateDataFalse") : t("notificationsTable.stateDataTrue"),
      viewBool: notification.view,
      notificationContent: notification.notificationContent,
      createdAt: formatToSpanishTimeZone(notification.createdAt)
    }))

    return notifications;
  } catch (error) {
    // console.error("Error during login:", error);
    // Manejar el error
    throw error;
  }
}

export async function PatchNotificationViewService(incident) {
  try {
    const data = await PatchNotificationView(incident, responsible);
  } catch (error) {

  }
}

export async function PatchNotificationViewFeedbackService(notification) {
  try {
    const data = await PatchNotificationViewFeedback(notification, responsible);
  } catch (error) {
    console.error('Error PatchNotificationViewFeedbackService', error)

  }
}